import { Hub } from "../models/hub";

export default function isHubActivated(hub: Hub | null) {
    if (!hub) return null;

    if (!hub.subscription_start || !hub.subscription_end) return false;

    const now = new Date();
    const start = new Date(hub.subscription_start);
    const end = new Date(hub.subscription_end);

    return now >= start && now <= end;
  };
